import { useEffect } from "react";
import { STATEMENT_KEYS } from "../data/statements";
import { Link } from "react-router";
import translate from "../locales";

export function ChooseTheme() {
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.fathom) {
        window.fathom.trackPageview({ url: window.location.toString() });
        clearInterval(interval);
      }
    }, 250);

    return () => clearInterval(interval);
  }, []);

  return (
    <main className="app__container">
      <div className="card">
        <div className="card__intro">
          <h2 className="card__title">{translate("intro.title")}</h2>
          <p className="card__description">{translate("intro.description")}</p>
        </div>

        {STATEMENT_KEYS.map((key) => (
          <Link to={key} key={key} className="link-card">
            {translate(["statements", key, "name"])}
          </Link>
        ))}
      </div>
    </main>
  );
}
